import Api from "../../../library/api";
import { showError } from "../../snackbars/snackbars-actions";

export const REQUEST_ADD_USER = "REQUEST_ADD_USER";
export const ADD_USER_FAILED = "ADD_USER_FAILED";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";

export function requestAddUser(payload, responseCallback) {
  return dispatch => {
    dispatch({ type: REQUEST_ADD_USER });

    Api.post("p/add-user", payload).then(resp => {
      if (resp.err) {
        responseCallback(false);
        dispatch({ type: ADD_USER_FAILED });
        dispatch(showError(resp.err));
        return;
      }
      responseCallback(true);
      dispatch({
        type: ADD_USER_SUCCESS,
        data: payload
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-form/users-form-actions.js